import LazyUtil from "../../../core/util/lazy_util";
import { SignUpPromotionAction } from '../../actions/sign_up_promotion_action';

export class SignUpPromotionContainer{
  constructor() {

    LazyUtil.registerFiredEvent(
      'signUpPromotionExternalFile',
      () => {
        // 販促エリア [x]ボタン押下時
        document.querySelector('#signUpPromotionArea button.close')?.addEventListener('click', function () {
          SignUpPromotionAction.closeButtonClick();
        });
    });
  }
}
